import { c as _c } from "react/compiler-runtime";
import React from "react";
import { cn } from "@repo/ui/utils.ts";
import { PortableText, type PortableTextReactComponents } from "next-sanity";
import { asPortableText, hardBreakHandler, linkMarkHandler, onMissingPortableTextComponent, proseBaseClasses } from "./shared";

/**
 * Dedicated component for the `richTextCaption` schema.
 *
 * Schema permits: `normal` blocks; `strong` and `em` decorators; `link`
 * annotation. Used for image captions where paragraphs are visually a
 * single line — the wrapper neutralises top/bottom margins on `<p>`.
 */
const components: Partial<PortableTextReactComponents> = {
  marks: {
    link: linkMarkHandler
  },
  hardBreak: hardBreakHandler
};
interface RichTextCaptionProps<T = unknown> {
  richText?: T | null;
  className?: string;
}
export function RichTextCaption(t0) {
  const $ = _c(9);
  const {
    richText,
    className
  } = t0;
  if (!richText) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cn(proseBaseClasses, "typography-body-sm-regular text-text-secondary [&>p]:m-0", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== richText) {
    t2 = asPortableText(richText);
    $[2] = richText;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <PortableText value={t2} components={components} onMissingComponent={onMissingPortableTextComponent} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <div className={t1}>{t3}</div>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}